// extracted by mini-css-extract-plugin
export default {"CreateMainContainer":"CreateBucket_CreateMainContainer__eBjTn","firstChildDiv":"CreateBucket_firstChildDiv__E+SW0","inputDiv":"CreateBucket_inputDiv__JrHpC"};